export const getStyled = (theme) => ({
  mainContainer: {
    flex: 1,
    padding: theme.spacing(2),
    height: `calc(100% - 48px)`,
  },

  contentWrapper: {
    height: '100%',
    overflowY: 'hidden',
    display: 'flex',
    flexDirection: 'column',
  },
});
